import { useQuery } from 'react-query';
import { channelConcurrencyGroupsQuery, configQuery } from './queries';

export function useConfig() {
  return useQuery(configQuery());
}

export function useConcurrencyChannelGroup() {
  return useQuery(channelConcurrencyGroupsQuery());
}
